import { render, staticRenderFns } from "./cards-board-columns.vue?vue&type=template&id=3ac15fd1&scoped=true"
import script from "./cards-board-columns.vue?vue&type=script&lang=js"
export * from "./cards-board-columns.vue?vue&type=script&lang=js"
import style0 from "./cards-board-columns.vue?vue&type=style&index=0&id=3ac15fd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac15fd1",
  null
  
)

export default component.exports